import { render, staticRenderFns } from "./newbooking.vue?vue&type=template&id=0fd4c128&scoped=true"
import script from "./newbooking.vue?vue&type=script&lang=js"
export * from "./newbooking.vue?vue&type=script&lang=js"
import style0 from "./newbooking.vue?vue&type=style&index=0&id=0fd4c128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4c128",
  null
  
)

export default component.exports